import { TaxonomySummary } from 'src/shared/types/graph/project';

/**
 * Gets the total count of unique species from taxonomy summary
 */
export const getTotalSpeciesCount = (taxonomySummary: TaxonomySummary | undefined): number => {
    if (!taxonomySummary) return 0;
    const unique = new Set<string>();
    taxonomySummary.forEach(item => {
        const nmSeqId = item?.nmSeqId ?? '';
        if (nmSeqId) unique.add(nmSeqId);
    });
    return unique.size;
};

/**
 * Gets the count of unique invasive species from taxonomy summary
 */
export const getInvasiveSpeciesCount = (taxonomySummary: TaxonomySummary | undefined): number => {
    if (!taxonomySummary) return 0;
    const unique = new Set<string>();
    taxonomySummary.forEach(item => {
        const name = item?.taxonomy?.tax_species ?? '';
        const status = item?.conservationStatus?.onGRIISList as unknown;
        const isInvasive = status === true || status === 'Invasive';
        if (name && isInvasive) unique.add(name);
    });
    return unique.size;
};

/**
 * Gets the count of unique IUCN Red List species from taxonomy summary
 */
export const getRedListSpeciesCount = (taxonomySummary: TaxonomySummary | undefined): number => {
    if (!taxonomySummary) return 0;
    const unique = new Set<string>();
    taxonomySummary.forEach(item => {
        const name = item?.taxonomy?.tax_species ?? '';
        const status = item?.conservationStatus?.iucnRedListStatus ?? '';
        // Include only specific IUCN statuses same as implemented in Dashboard
        const isValidIucnStatus = status && ['CR', 'EN', 'VU', 'NT'].includes(status);
        if (name && isValidIucnStatus) {
            unique.add(name);
        }
    });
    return unique.size;
};
